module.exports = __webpack_public_path__ + "static/media/about_page_bg.ba23b4a0.jpg";